/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ASP.NET 8 Web API for RIGHTIO Booking System - DEVELOPMENT
 * This is the API for the RIGHTIO Booking System, it is used to provide the booking system with data and to update the booking system with data.
 * OpenAPI spec version: v1
 */
import type {
  RightioWBSAPIModelsCompanyProfile
} from '../../model';

import { customInstance } from '../../../../../services/DatabaseAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Retrieves comprehensive company profile information from the UK Companies House registry including status, addresses, filing history, and compliance details for business verification.
 * @summary Get company details from Companies House
 */
export const companiesHouseGetCompanyDetails = (
    regNumber: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCompanyProfile>(
      {url: `/api/payments/CompaniesHouse/company/${regNumber}`, method: 'GET'
    },
      options);
    }
  export type CompaniesHouseGetCompanyDetailsResult = NonNullable<Awaited<ReturnType<typeof companiesHouseGetCompanyDetails>>>
